<template>
	<section class="dosage-product">
		<PopupProductAnnotation
			v-if="showAnnotationProduct"
			:product="annotationProduct"
			@close="closeAnnotationProduct"
			@save="save" />
		<PopupProductDetail
			v-if="showProductDetail"
			@close="showProductDetail = false" />
		<PopupMassiveActionDosageProduct
			v-if="showMassiveAction"
			:show-totals="showTotals"
			:show-sector-details="showSectorDetails"
			:isIrrigationMasiveAction="isIrrigationMasiveAction"
			:massive-action-product="massiveActionProduct"
			@closeMassiveAction="showMassiveAction = false"
			@saveMassiveActions="handleMassiveActionSave"
			@saveMassiveIrrigation="handleMassiveIrrigationSave"
			:init-value="stepData.initDate"
			:end-value="stepData.endDate"
			:temporal-frame="stepData.temporalFrame.value" />
		<PopupSelectionSelect
			v-if="showSectorModal"
			:selectedSectorCell="selectedSectorCell"
			@close="showSectorModal = false"
			@save="handleSectorSave" />
		<PopupNutritionalBalance
			v-if="showNutritionProductDetail"
			:nutritionProduct="nutritionProduct"
			@close="showNutritionProductDetail = false" />
		<div class="content-devx">
			<div class="card-header">
				{{ $t('dosageProduct.title') }}
			</div>
			<div
				class="card-body margin-left-block margin-right-block margin-bottom-block">
				<section class="top">
					<DxDataGrid
						:key="dosageProductBalanceKey"
						class="data-grid-balance-value"
						:data-source="dosageProductBalance"
						:show-borders="true">
						<DxColumn
							data-field="uf"
							:caption="$t('dosageProduct.uf')"
							:width="200"
							:allow-sorting="false" />
						<DxColumn
							:caption="$t('dosageProduct.n')"
							data-field="n"
							data-type="number"
							:allow-sorting="false" />
						<DxColumn
							:caption="$t('dosageProduct.p')"
							data-field="p"
							data-type="number"
							:allow-sorting="false" />
						<DxColumn
							:caption="$t('dosageProduct.k')"
							data-field="k"
							data-type="number"
							:allow-sorting="false" />
						<DxColumn
							:caption="$t('dosageProduct.c')"
							data-field="c"
							data-type="number"
							:allow-sorting="false" />
						<DxColumn
							:caption="$t('dosageProduct.m')"
							data-field="m"
							data-type="number"
							:allow-sorting="false" />
						<DxColumn
							:caption="$t('dosageProduct.s')"
							data-field="s"
							data-type="number"
							:allow-sorting="false" />
					</DxDataGrid>
				</section>

				<section
					class="search margin-top-block margin-bottom-block"
					style="margin-top: 1.4rem">
					<div class="options-bar">
						<div class="options-bar__add-product">
							<div class="margin-right-block">
								{{ $t('dosageProduct.searchFertilizer') }}
							</div>
							<div
								class="margin-right-block width300"
								style="position: relative">
								<Spinner
									v-if="loadingProductFertilizers"
									size="25px"
									style="
										position: absolute;
										z-index: 50;
										right: 5px;
										top: 5px;
									" />
								<DxSelectBox
									ref="product-fertilizer"
									:data-source="productFertilizersPaginated"
									display-expr="name"
									:search-enabled="true"
									value-expr="id"
									item-template="product-name"
									:search-expr="['name', 'code']"
									:placeholder="
										$t('treatment.treatmentEditOrder.products.typeToSearch')
									"
									:no-data-text="$t('No_Data')"
									width="auto"
									:disabled="loadingProductFertilizers"
									@value-changed="selectProductItem">
									<template #product-name="{ data }">
										<div>
											<div
												v-if="data.presentation"
												style="display: flex; justify-content: flex-end">
												<span
													style="
														font-size: 0.75rem;
														background: #e5e7eb;
														padding: 0 0.4rem;
														border-radius: 9999px;
														text-align: center;
													">
													{{ data.presentation }}
												</span>
											</div>
											<div
												class="text-color-gray"
												style="word-break: break-all">
												{{ data.code }}
											</div>
											<div style="word-break: break-all">
												{{ data.name }}
											</div>
										</div>
									</template>
								</DxSelectBox>
							</div>
							<DxButton
								:text="$t('dosageProduct.add')"
								type="default"
								@click="addProductFertilizer" />
						</div>
						<div class="options-bar__utilities">
							<div class="options-bar__utilities__item">
								<label for="unit-selectbox">Unidades</label>
								<DxSelectBox
									id="unit-selectbox"
									:items="unitOptions"
									v-model="selectedUnit"
									value-expr="id"
									display-expr="label"
									:search-enabled="false"
									:show-clear-button="false"
									:defer-rendering="false"
									:width="180" />
							</div>
							<div class="options-bar__utilities__item">
								<label for="show-totals-radio">Ver totales</label>
								<DxRadioGroup
									id="show-totals-radio"
									:items="yesNoOptions"
									:value="showTotals"
									:valueExpr="'value'"
									:displayExpr="'text'"
									layout="horizontal"
									@value-changed="onShowTotalsChanged" />
							</div>
							<div
								v-if="stepData.temporalFrame.value === 'DIARIO'"
								class="options-bar__utilities__item">
								<label
									class="options-bar__item__text"
									for="sector-details-radio"
									>Detalles por sectores</label
								>
								<DxRadioGroup
									id="sector-details-radio"
									:items="yesNoOptions"
									:value="showSectorDetails"
									:valueExpr="'value'"
									:displayExpr="'text'"
									layout="horizontal"
									@value-changed="onShowSectorDetailsChanged" />
							</div>
						</div>
					</div>
				</section>
				<section class="bottom">
					<!-- DATA GRID agrupado por año, mes y día -->
					<div class="data-grid-time-product">
						<DxDataGrid
							:data-source="
								hasLiquidProducts
									? [...gridTimeRows, totalRow, totalRowOnlyLiquid]
									: [...gridTimeRows, totalRow]
							"
							:show-borders="true"
							:allow-sorting="false"
							:column-auto-width="true"
							@editor-preparing="onEditorPreparing"
							@row-updated="onRowUpdated"
							@cell-click="onSectorCellClick"
							:height="'100%'"
							@cell-prepared="onCellPrepared">
							<DxScrolling v-if="isDesktop" column-rendering-mode="virtual" />

							<DxPaging :enabled="false" />
							<DxEditing
								:allow-updating="
									({ row }) =>
										row &&
										row.data &&
										row.data.year !== 'Totales' &&
										row.data.year !== 'Total líquidos g-Kg'
								"
								mode="cell" />
							<DxColumnFixing :enabled="true" />
							<DxColumn
								alignment="center"
								:width="100"
								data-field="year"
								caption="Año"
								:allow-editing="false"
								:allow-sorting="false"
								:input-attr="{ class: 'date-column' }"
								:fixed="true"
								css-class="row-header" />
							<DxColumn
								alignment="center"
								:width="150"
								data-field="month"
								caption="Mes"
								:allow-editing="false"
								:allow-sorting="false"
								:fixed="true"
								css-class="text-cell row-header" />
							<DxColumn
								v-if="
									stepData.temporalFrame.value === 'SEMANAL' ||
									stepData.temporalFrame.value === 'DIARIO'
								"
								alignment="center"
								:width="100"
								data-field="periodo"
								:caption="
									stepData.temporalFrame.value === 'SEMANAL' ? 'Semana' : 'Día'
								"
								:allow-editing="false"
								:allow-sorting="false"
								:fixed="true"
								css-class="row-header" />
							<!-- Columnas dinámicas por producto -->
							<DxColumn
								v-if="stepData.dosageProduct.length === 0"
								:visible="true"
								:width="0" />
							<DxColumn
								v-for="(product, index) in stepData.dosageProduct"
								:key="'product-col-' + index"
								:caption="product.name"
								:header-cell-template="`productHeaderTemplateActions${index}`"
								alignment="center"
								:allow-sorting="false">
								<DxColumn
									v-for="(subCol, subIdx) in getAllSubColumns(product)"
									class="sub-column"
									:key="`subcol-${index}-${subIdx}`"
									:caption="subCol.caption"
									:data-field="subCol.dataField"
									:allow-editing="true"
									:allow-sorting="false"
									:min-width="columnWidth"
									:width="columnWidth"
									alignment="right"
									:cell-template="
										subCol.dataField.endsWith('_sectores')
											? 'sectorCellTemplate'
											: undefined
									"
									v-bind="
										subCol.dataField.endsWith('_sectores')
											? {}
											: { 'data-type': 'number' }
									"
									:visible="subCol.visible" />
							</DxColumn>
							<!-- Header templates para los botones de acción de cada producto (fila superior) -->
							<template
								v-for="(product, index) in stepData.dosageProduct"
								v-slot:[`productHeaderTemplateActions${index}`]="{ column }">
								<div class="product-column">
									<div class="product-column__actions">
										<DxButton
											styling-mode="text"
											icon="event"
											type="default"
											@click="
												openMassiveAction({ row: { rowIndex: index } })
											" />
										<DxButton
											styling-mode="text"
											icon="edit"
											@click="
												openProductAnnotations({ row: { rowIndex: index } })
											" />
										<DxButton
											styling-mode="text"
											type="success"
											icon="find"
											@click="viewProduct({ data: { id: product.id } })" />
										<!-- <DxButton
                      styling-mode="text"
                      type="defaoult"
                      icon="info"
                      @click="
                        viewNutritionProduct({ data: { id: product.id } })
                      "
                    /> -->
										<DxButton
											styling-mode="text"
											type="danger"
											icon="trash"
											@click="deleteItem({ row: { rowIndex: index } })" />
									</div>
									<div class="product-column__title">
										{{ product.name }}
									</div>
								</div>
							</template>
							<DxColumn
								v-if="stepData.temporalFrame.value === 'DIARIO'"
								data-field="irrigationTime"
								alignment="center"
								:allow-editing="true"
								:allow-sorting="false"
								:fixed="true"
								:fixed-position="'right'"
								:width="180"
								header-cell-template="irrigationTimeHeaderTemplate" />
							<template #irrigationTimeHeaderTemplate>
								<div
									style="
										display: flex;
										flex-direction: column;
										align-items: center;
									">
									<DxButton
										styling-mode="text"
										icon="event"
										type="default"
										@click="
											openMassiveAction(
												{
													row: { rowIndex: null },
												},
												true,
											)
										" />

									<span>Tiempo de Riego (hh:mm)</span>
								</div>
							</template>
							<template #sectorCellTemplate="{ data }">
								{{ formatSectorCell(data) }}
							</template>
						</DxDataGrid>
					</div>
					<!-- FIN DATA GRID VALORES DE TIEMPO -->
				</section>
				<section
					v-if="
						stepData.temporalFrame.value === 'DIARIO' &&
						stepData.initDate &&
						stepData.endDate
					"
					class="irrigation-calendars">
					<div class="irrigation-calendars__item">
						<CalendarView
							:startDate="stepData.initDate"
							:endDate="stepData.endDate"
							:customDatesOne="irrigationDates"
							:customDatesTwo="fertirrigationDates" />
					</div>
					<div class="irrigation-calendars__item">
						<div class="calendar-legend">
							<span class="calendar-legend__item">
								<span
									class="calendar-legend__color calendar-legend__color--irrigation"></span>
								Días con riego
							</span>
							<span class="calendar-legend__item">
								<span
									class="calendar-legend__color calendar-legend__color--fertilization"></span>
								Días con fertilización
							</span>
						</div>
					</div>
				</section>
			</div>
		</div>

		<!--SECCION DE TABLA DE RIEGO-->
		<section v-if="showOldIrrigationTable" class="content-devx">
			<div class="button-irrigation">
				<div class="button-recalculate">
					<DxButton
						v-if="showButtonRecalculate"
						:text="$t('dosageProduct.recalculate')"
						type="default"
						@click="recalculateIrrigationTable" />
				</div>
				<DxButton
					:text="buttonMessageIrrigation"
					type="default"
					@click="toggleIrrigationTable" />
			</div>
			<div
				v-if="showIrrigationTable"
				class="card-body margin-left-block margin-right-block margin-bottom-block">
				<DxDataGrid
					id="irrigationTable"
					class="data-grid-reference-value"
					:data-source="stepData.irrigationTable"
					:show-borders="true"
					@row-updated="handleCellValueChanging">
					<DxEditing :allow-updating="true" mode="cell" />
					<DxColumn caption="">
						<DxColumn
							caption=""
							data-field="week"
							:allow-editing="false"
							:allow-sorting="false" />
					</DxColumn>
					<DxColumn
						v-for="(product, index) in stepData.dosageProduct"
						:key="`${product.code}_${index}`"
						:caption="`${product.name}`">
						<DxColumn
							:caption="'NºRiegos'"
							:data-field="`periods_product_irrigation_${index}`"
							data-type="number"
							:allow-editing="true" />
						<DxColumn
							:caption="product.caption"
							:data-field="`periods_dose_${index}`"
							data-type="number"
							:allow-editing="false" />
					</DxColumn>
					<DxColumn
						:caption="'NºTotal de riegos'"
						data-field="periods_irrigation"
						data-type="number"
						:allow-editing="true" />
					<DxColumn
						:caption="'Tiempo/Riego(horas)'"
						data-field="periods_irrigation_time"
						data-type="number"
						:allow-editing="true" />
				</DxDataGrid>
			</div>
		</section>
	</section>
</template>
<script>
	import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
	import {
		DxDataGrid,
		DxColumn,
		DxSorting,
		DxScrolling,
		DxPaging,
		DxColumnFixing,
		DxEditing,
	} from 'devextreme-vue/data-grid';
	import { DxButton } from 'devextreme-vue/button';
	import { DxSelectBox } from 'devextreme-vue/select-box';
	import { DxRadioGroup } from 'devextreme-vue/radio-group';
	import { mapState, mapActions, mapGetters } from 'vuex';
	import moment from 'moment';
	import { Device } from 'framework7/framework7-lite.esm.bundle';
	import { DxPopover } from 'devextreme-vue/popover';
	import DataSource from 'devextreme/data/data_source';
	import { uniqueId } from 'lodash';
	import PopupProductDetail from '../popupProductDetail/index.vue';
	import PopupProductAnnotation from '../PopupProductAnnotation/index.vue';
	import Api from '../../../services/Api';
	import Spinner from '../../spinner.vue';
	import { getTimeValuesExtended } from '../../../js/utils/timeValuesExtendedUtils';
	import { DxTagBox } from 'devextreme-vue/tag-box';
	import PopupMassiveActionDosageProduct from '../popUpMassiveActionDosageProduct/index.vue';
	import CalendarView from '../../CalendarViewer/CalendarViewer.vue';
	import PopupSelectionSelect from './PopupSelectionSelect/PopupSelectionSelect.vue';
	import PopupNutritionalBalance from '../PopupNutritionalBalance/index.vue';

	export default {
		name: 'DosageProduct_nutrition',
		components: {
			DxLoadIndicator,
			DxDataGrid,
			DxColumn,
			DxButton,
			DxSelectBox,
			DxColumnFixing,
			DxSorting,
			DxScrolling,
			DxPaging,
			DxEditing,
			DxRadioGroup,
			PopupProductDetail,
			DxPopover,
			PopupProductAnnotation,
			Spinner,
			DxTagBox,
			PopupMassiveActionDosageProduct,
			CalendarView,
			PopupSelectionSelect,
			PopupNutritionalBalance,
		},
		data() {
			return {
				productFertilizerSelected: '',
				productFertilizerSelectedValue: '',
				availableProductFertilizers: [],
				buttonMessageIrrigation: this.$t('dosageProduct.addIrrigationTable'),
				showProductDetail: false,
				showAnnotationProduct: false,
				showIrrigationTable: false,
				showMassiveAction: false,
				annotationProduct: null,
				massiveActionProduct: null,
				environment: process.env.NODE_ENV,
				visible: false,
				currentRowIndex: 0,
				dosageProductBalanceKey: 'dosage-product-balance-key',
				keyGridDosages: 'key-grid-dosages',
				previousRowValues: {},
				unitOptions: [
					{ id: 1, label: 'Kg-L/ha' },
					{ id: 2, label: 'g-cm3/pie' },
				],
				selectedUnit: 1,
				yesNoOptions: [
					{ value: true, text: 'Sí' },
					{ value: false, text: 'No' },
				],
				isIrrigationMasiveAction: false,
				showSectorModal: false,
				selectedSectorCell: {},
				showNutritionProductDetail: false,
				nutritionProduct: {},
				reportMessage: '',
				showOldIrrigationTable: false,
			};
		},
		computed: {
			...mapGetters('nutritionStepper', ['stepData']),
			...mapGetters('productFertilizerStore', ['productFertilizers']),
			...mapState('productFertilizerStore', ['loadingProductFertilizers']),
			...mapState('Plantation', ['currentPlantation']),
			...mapState('RegisterPlantation', ['actualPlantation']),
			...mapState('Nutrition', ['productsNotInNutritionPlan']),
			...mapState('nutritionStepper', [
				'isEditing',
				'editingStepData',
				'isCopying',
				'copyingStepData',
				'isNew',
			]),
			columnWidth() {
				return this.showTotals || this.showSectorDetails ? 100 : 180;
			},
			isDesktop() {
				return Device.desktop;
			},
			hasLiquidProducts() {
				return this.stepData.dosageProduct.some(
					(product) => product.presentation === 'LIQUIDO',
				);
			},
			showTotals() {
				return this.stepData.nutritionIrrigationData?.showTotals ?? false;
			},
			showSectorDetails() {
				return (
					this.stepData.nutritionIrrigationData?.showSectorDetails ?? false
				);
			},
			gridTimeRows() {
				return this.dataSourceDates.map((dateRow, idx) => ({
					...dateRow,
					...(this.stepData.timeValues[idx] || {}),
				}));
			},
			dosagesProduct() {
				return this.stepData.dosages.map((product, index) => ({
					...product,
					id: this.stepData.dosageProduct[index].id,
				}));
			},
			showButtonRecalculate() {
				return (
					this.buttonMessageIrrigation ===
					this.$t('dosageProduct.deleteIrrigationTable')
				);
			},
			productFertilizersPaginated() {
				return new DataSource({
					store: this.availableProductFertilizers,
					paginate: true,
					pageSize: 100,
				});
			},
			dosageProductBalance() {
				return this.stepData.dosageProductBalance.map((item) => {
					if (!item) return item;
					return {
						c: this.fixNumberTo(item.c, 0),
						k: this.fixNumberTo(item.k, 0),
						m: this.fixNumberTo(item.m, 0),
						n: this.fixNumberTo(item.n, 0),
						p: this.fixNumberTo(item.p, 0),
						s: this.fixNumberTo(item.s, 0),
						uf: item.uf,
					};
				});
			},
			getIconPath() {
				if (Device.cordova) {
					return this.environment === 'development'
						? '../../../static/img/'
						: 'static/img/';
				}
				return this.environment === 'development'
					? '../../../static/img/'
					: './static/img/';
			},
			dataSourceDates() {
				const temporalFrame = this.stepData.temporalFrame.value;
				const result = [];
				const monthNames = [
					'enero',
					'febrero',
					'marzo',
					'abril',
					'mayo',
					'junio',
					'julio',
					'agosto',
					'septiembre',
					'octubre',
					'noviembre',
					'diciembre',
				];
				const getMonthNumber = (monthName) => {
					const idx = monthNames.indexOf(monthName.toLowerCase());
					return idx !== -1 ? String(idx + 1).padStart(2, '0') : '01';
				};
				if (temporalFrame === 'SEMANAL') {
					const start = moment(this.stepData.initDate);
					const end = moment(this.stepData.endDate);
					let current = start.clone().startOf('isoWeek');
					let lastWeek = null;
					while (current.isSameOrBefore(end, 'day')) {
						const weekNumber = current.isoWeek();
						const weekStart = current.clone();
						const weekEnd = current.clone().endOf('isoWeek');
						if (weekEnd.isBefore(start, 'day')) {
							current.add(1, 'week');
							continue;
						}
						if (lastWeek !== weekNumber) {
							result.push({
								year: weekStart.year(),
								month: weekStart.locale('es').format('MMMM'),
								periodo: `Semana ${weekNumber}`,
								key: weekStart.format('YYYY-MM-DD'),
							});
							lastWeek = weekNumber;
						}
						current.add(1, 'week');
					}
				} else if (temporalFrame === 'DIARIO') {
					this.yearMonthDayStructure.forEach((year) => {
						year.months.forEach((month) => {
							const monthNum = getMonthNumber(month.month);
							month.days.forEach((day) => {
								const dateStr = `${year.year}-${monthNum}-${day}`;
								const date = moment.utc(dateStr, 'YYYY-MM-DD');
								result.push({
									year: year.year,
									month: month.month,
									periodo: day || '',
									key: date.isValid() ? date.format('YYYY-MM-DD') : '',
								});
							});
						});
					});
				} else {
					const initDay = moment(this.stepData.initDate, 'YYYY-MM-DD').format('DD');

					this.yearMonthDayStructure.forEach((year) => {
						year.months.forEach((month) => {
							const monthNum = getMonthNumber(month.month);
							// intenta YYYY-MM-initDay (ej 2021-11-03)
							let date = moment.utc(`${year.year}-${monthNum}-${initDay}`, 'YYYY-MM-DD', true);

							//si ese día no existe, caemos al último día del mes
							if (!date.isValid()) {
								date = moment
								.utc(`${year.year}-${monthNum}-01`, 'YYYY-MM-DD', true)
								.endOf('month');
							}
							result.push({
								year: year.year,
								month: month.month,
								periodo: '',
								key: date.isValid() ? date.format('YYYY-MM-DD') : '',
							});
						});
					});
				}
				let prevYear = null,
					prevMonth = null;
				result.forEach((row) => {
					if (row.year === prevYear) row.year = '';
					else prevYear = row.year;
					if (row.month === prevMonth && row.year === '') row.month = '';
					else prevMonth = row.month;
				});
				return result;
			},
			yearMonthDayStructure() {
				const start = moment(this.stepData.initDate);
				const end = moment(this.stepData.endDate);
				const result = [];
				let current = start.clone().startOf('day');
				while (current.isSameOrBefore(end, 'day')) {
					const year = current.year();
					const month = current.locale('es').format('MMMM');
					const day = current.format('DD');
					let yearObj = result.find((y) => y.year === year);
					if (!yearObj) {
						yearObj = { year, months: [] };
						result.push(yearObj);
					}
					let monthObj = yearObj.months.find((m) => m.month === month);
					if (!monthObj) {
						monthObj = { month, days: [] };
						yearObj.months.push(monthObj);
					}
					monthObj.days.push(day);
					current.add(1, 'day');
				}
				return result;
			},
			totalRow() {
				const columns = ['year', 'month', 'periodo'];
				const productCols = this.stepData.dosageProduct.map((_, i) => i);
				const total = {};
				columns.forEach(
					(col) => (total[col] = col === 'year' ? 'Totales' : ''),
				);
				productCols.forEach((idx) => {
					this.getAllSubColumns(this.stepData.dosageProduct[idx]).forEach(
						(subCol) => {
							// No sumar la columna sectores
							if (subCol.dataField.endsWith('_sectores')) {
								total[subCol.dataField] = null;
							} else {
								const sum = (this.stepData.timeValues || []).reduce(
									(acc, row) => acc + (parseFloat(row[subCol.dataField]) || 0),
									0,
								);
								total[subCol.dataField] = Math.round(sum * 10) / 10;
							}
						},
					);
				});
				// Sumar la columna de Tiempo de Riego (irrigationTime)
				total.irrigationTime = (this.stepData.timeValues || []).reduce(
					(acc, row) => {
						if (row.irrigationTime) {
							const [h, m] = String(row.irrigationTime).split(':');
							acc += parseInt(h || 0) * 60 + parseInt(m || 0);
						}
						return acc;
					},
					0,
				);

				// Mostrar el total en formato h:mm:
				const totalHours = Math.floor(total.irrigationTime / 60);
				const totalMinutes = total.irrigationTime % 60;
				if (total.irrigationTime === 0) {
					total.irrigationTime = '0';
				} else {
					if (totalMinutes === 0) {
						total.irrigationTime = `${totalHours}`;
					} else {
						total.irrigationTime = `${totalHours}:${totalMinutes
							.toString()
							.padStart(2, '0')}`;
					}
				}

				return total;
			},
			totalRowOnlyLiquid() {
				const columns = ['year', 'month', 'periodo'];
				const productCols = this.stepData.dosageProduct
					.map((product, i) => ({ product, i }))
					.filter(({ product }) => product.presentation === 'LIQUIDO');
				const total = {};
				columns.forEach(
					(col) => (total[col] = col === 'year' ? 'Total líquidos g-Kg' : ''),
				);
				productCols.forEach(({ product, i }) => {
					this.getAllSubColumns(product).forEach((subCol) => {
						// Igual que en totalRow: no sumar la columna sectores
						if (subCol.dataField.endsWith('_sectores')) {
							total[subCol.dataField] = null;
						} else {
							const sum = (this.stepData.timeValues || []).reduce(
								(acc, row) => acc + (parseFloat(row[subCol.dataField]) || 0),
								0,
							);
							const data = {
								presentation: product.presentation,
								density: product.density,
								dosage: isNaN(sum) ? 0 : Math.round(sum * 10) / 10,
							};
							total[subCol.dataField] = this.getDosageKg(data);
						}
					});
				});
				return total;
			},
			irrigationDates() {
				// Devuelve un array de claves de fecha donde hay tiempo de riego pero NO hay dosis NI totales en ningún producto
				return this.stepData.timeValues
					.map((row, idx) => {
						const hasIrrigation = !!row.irrigationTime;
						// Busca si hay alguna dosis o totales para cualquier producto en esta fila
						const hasAnyDoseOrTotal = this.stepData.dosageProduct.some(
							(product) => {
								const doseField = `${product.code}_dosis`;
								const totalField = `${product.code}_totales`;
								return (
									(row[doseField] !== null &&
										row[doseField] !== undefined &&
										row[doseField] !== '') ||
									(row[totalField] !== null &&
										row[totalField] !== undefined &&
										row[totalField] !== '')
								);
							},
						);
						if (hasIrrigation && !hasAnyDoseOrTotal) {
							return this.dataSourceDates[idx]?.key;
						}
						return null;
					})
					.filter((key) => !!key);
			},
			fertirrigationDates() {
				// Devuelve un array de claves de al menos una dosis o totales en algún producto
				return this.stepData.timeValues
					.map((row, idx) => {
						const hasAnyDoseOrTotal = this.stepData.dosageProduct.some(
							(product) => {
								const doseField = `${product.code}_dosis`;
								const totalField = `${product.code}_totales`;
								return (
									(row[doseField] !== null &&
										row[doseField] !== undefined &&
										row[doseField] !== '') ||
									(row[totalField] !== null &&
										row[totalField] !== undefined &&
										row[totalField] !== '')
								);
							},
						);
						if (hasAnyDoseOrTotal) {
							return this.dataSourceDates[idx]?.key;
						}
						return null;
					})
					.filter((key) => !!key);
			},
		},
		watch: {
			'stepData.timeValues': {
				handler(val) {
					if (val.length === 0) return;
					this.calcTotalBalance(val);
					this.calculateUfEficency(val);
				},
				deep: true,
			},
			selectedUnit: {
				handler(newUnit) {
					if (this.showTotals) {
						this.fillTotalsFromDosis();
					}
					this.calcTotalBalance(this.stepData.timeValues);
					this.calculateUfEficency(this.stepData.timeValues);
					this.stepData.nutritionIrrigationData.dosis_unit = newUnit;
				},
			},
		},
		created() {
			this.getProductFertilizers(this.currentPlantation.companyId).then(() => {
				this.syncAvailableProductFertilizers();
			});
			this.showOldIrrigationTable = this.currentPlantation.old_irrigation_table;
			this.mapNutritionIrrigationDataToGrid();
			this.stepData.dosages = this.calculateDosagesFromTimeValues();
			this.selectedUnit =
				this.stepData?.nutritionIrrigationData?.dosis_unit || this.selectedUnit;

			if (this.stepData.dosageProduct.length > 0) {
				if (this.stepData.dosageProductBalance.length === 1) {
					this.stepData.dosageProductBalance.push(
						this.getRowDataSource(this.$t('dosageProduct.finalBalance')),
					);
					this.calcTotalBalance(this.stepData.timeValues);
				}
				return;
			}
			// no resetear estado al editar
			if (this.isEditing) {
				// reintento si hay data v2
				if (this.stepData?.nutritionIrrigationData?.data?.length > 0) {
					this.mapNutritionIrrigationDataToGrid();
					this.stepData.dosages = this.calculateDosagesFromTimeValues();
				}
				return;
			}

			this.stepData.dosageProductBalance = [];
			this.stepData.dosageProduct = [];
			this.stepData.timeValues = [];
			this.stepData.dosages = [];
			this.stepData.nutritionIrrigationData = {
				dosis_unit: 1,
				showTotals: false,
				showSectorDetails: false,
				data: [],
			};
			this.stepData.dosageProductBalance.push(
				this.stepData.nutritionalBalanceData[5],
			);
			if (this.isNew) {
				this.stepData.dosageProductBalance.push(
					this.getRowDataSource('UF teóricas'),
				);
				this.stepData.dosageProductBalance.push(
					this.getRowDataSource('UF eficientes aportadas'),
				);
			}
			if (!this.stepData.nutritionIrrigationData) {
				this.$set(this.stepData, 'nutritionIrrigationData', {
					dosis_unit: 1,
					showTotals: false,
					showSectorDetails: false,
					data: [],
				});
			}
			if (
				this.isEditing &&
				this.stepData.nutritionIrrigationData.data.length > 0
			) {
				this.mapNutritionIrrigationDataToGrid();
			}
			this.stepData.dosageProductBalance.push(
				this.getRowDataSource(this.$t('dosageProduct.finalBalance')),
			);
		},
		async beforeMount() {
			const FULL_EFFICIENCY = {
				n: 100,
				p: 100,
				k: 100,
				c: 100,
				m: 100,
				s: 100,
			};
			await Promise.all(
				this.stepData.dosageProduct.map(async (item) => {
					const hasReduction = item.reduction_percentage > 0;
					let eficiencies = FULL_EFFICIENCY;
					if (!hasReduction) {
						eficiencies = await Api.getProductEfficiency({
							code: item?.code,
							tipology: item?.tipology,
							ph: this.stepData.ph || 0,
						})
							.then((xhr) => {
								const data = JSON.parse(xhr.response);
								return {
									n: data.NT,
									p: data.P2015_Total,
									k: data.K2O,
									c: data.CaO,
									m: data.MgO,
									s: data.SO3,
								};
							})
							.catch(() => FULL_EFFICIENCY);
					}
					item.eficiencies = eficiencies;
					return item;
				}),
			);
			this.calcTotalBalance(this.stepData.timeValues);
			this.calculateUfEficency(this.stepData.timeValues);
			if (this.stepData.dosageProductBalance.length === 1) {
				this.stepData.dosageProductBalance.push(
					this.getRowDataSource(this.$t('dosageProduct.finalBalance')),
				);
			}
			this.calcTotalBalance(this.stepData.timeValues);
		},
		methods: {
			...mapActions('productFertilizerStore', ['getProductFertilizers']),
			...mapActions('Vademecum', ['getNutritionalProductDetail']),
			...mapActions('nutritionStepper', [
				'next',
				'back',
				'resetTimeValuesIrrigation',
			]),
			formatDate(str) {
				const [yyyy, mm, dd] = str.split('-');
				return `${dd}/${mm}/${yyyy}`;
			},
			isNullOrEmpty(value) {
				return value === null || value === '' || typeof value === 'undefined';
			},
			safeNumber(value) {
				return this.isNullOrEmpty(value) ? null : Number(value);
			},
			toArray(value) {
				if (this.isNullOrEmpty(value)) return null;
				return Array.isArray(value) ? value : [value];
			},
			normalizeDates(dates) {
				if (!Array.isArray(dates)) dates = [dates];
				return dates.map((date) => {
					if (typeof date === 'string') return date;
					if (date instanceof Date) return date.toISOString().slice(0, 10);
					return String(date);
				});
			},
			getDateStrFromRow(dateRow, temporalFrame) {
				if (!dateRow || !dateRow.key) return '';
				const [year, month, day] = dateRow.key.split('-');
				if (temporalFrame === 'DIARIO') {
					return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
				}
				if (temporalFrame === 'SEMANAL') {
					const startOfWeek = moment(dateRow.key, 'YYYY-MM-DD').startOf(
						'isoWeek',
					);
					return startOfWeek.format('YYYY-MM-DD');
				}
				return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
			},
			onCellPrepared(e) {
				if (
					e.rowType === 'data' &&
					(e.key.year === 'Totales' || e.key.year === 'Total líquidos g-Kg')
				) {
					e.cellElement.style.backgroundColor = '#D9D9D9';
					e.cellElement.style.border = '1px solid #c0c9ce';
					if (e.key.year === 'Totales') {
						e.cellElement.style.borderTop = '3px solid #c0c9ce';
					}
				}
			},
			combineYearMonthCells(timeValues) {
				let prevYear = null,
					prevMonth = null;
				timeValues.forEach((row) => {
					if (row.year === prevYear) row.year = '';
					else prevYear = row.year;
					if (row.month === prevMonth && row.year === '') row.month = '';
					else prevMonth = row.month;
				});
			},
			syncAvailableProductFertilizers() {
				const selectedIds = this.stepData.dosageProduct.map((p) => p.id);
				this.availableProductFertilizers = this.productFertilizers.filter(
					(p) => !selectedIds.includes(p.id),
				);
			},
			mapNutritionIrrigationDataToGrid() {
				this.stepData.timeValues = [];

				const getYearMonthPeriodo = (dateRow) => {
					if (!dateRow.key) return { year: '', month: '', periodo: '' };
					const [y, m, d] = dateRow.key.split('-');
					return {
						year: y,
						month: moment(m, 'MM').locale('es').format('MMMM'),
						periodo: d,
					};
				};
				const getDateObj = (year, month, formattedDate) => {
					const yearObj = this.stepData.nutritionIrrigationData.data.find(
						(yObj) => String(yObj.year) === String(year),
					);
					const monthObj = yearObj?.items?.find((mObj) => mObj.month === month);
					const dateObj = monthObj?.dates?.[formattedDate];
					return dateObj;
				};

				const getProdObj = (year, month, formattedDate, product) => {
					const dateObj = getDateObj(year, month, formattedDate);
					const prodObj = dateObj?.products?.find(
						(p) => p.prodId === product.id,
					);
					return { dateObj, prodObj };
				};

				const setSubColValue = (row, subCol, prodObj) => {
					if (subCol.dataField.endsWith('_dosis')) {
						row[subCol.dataField] =
							prodObj && !this.isNullOrEmpty(prodObj.dosis)
								? prodObj.dosis
								: null;
					} else if (subCol.dataField.endsWith('_totales')) {
						row[subCol.dataField] =
							prodObj && !this.isNullOrEmpty(prodObj.totals)
								? prodObj.totals
								: null;
					} else if (subCol.dataField.endsWith('_sectores')) {
						row[subCol.dataField] =
							prodObj && !this.isNullOrEmpty(prodObj.sectors)
								? prodObj.sectors
								: null;
					}
				};

				this.dataSourceDates.forEach((dateRow) => {
					const { year, month, periodo } = getYearMonthPeriodo(dateRow);
					const dateStr = this.getDateStrFromRow(
						dateRow,
						this.stepData.temporalFrame.value,
					);
					const formattedDate = this.formatDate(dateStr);

					let irrigationTimeValue =
						getDateObj(year, month, formattedDate)?.irrigationTime ??
						getDateObj(year, month, formattedDate)?.irrigation_time ??
						null;

					if (irrigationTimeValue !== null && irrigationTimeValue !== '') {
						irrigationTimeValue =
							this.formatIrrigationTime(irrigationTimeValue);
					}

					const row = {
						year,
						month,
						periodo:
							this.stepData.temporalFrame.value === 'SEMANAL'
								? dateRow.periodo
								: periodo,
						irrigationTime: irrigationTimeValue,
					};

					this.stepData.dosageProduct.forEach((product) => {
						const { prodObj } = getProdObj(year, month, formattedDate, product);

						this.getAllSubColumns(product).forEach((subCol) => {
							setSubColValue(row, subCol, prodObj);
						});
					});
					this.stepData.timeValues.push(row);
				});
				this.combineYearMonthCells(this.stepData.timeValues);
			},

			updateNutritionIrrigationData({
				year,
				month,
				dateStr,
				product,
				updatedRow,
				subCol,
			}) {
				const formattedDate = this.formatDate(dateStr);

				let yearObj = this.stepData.nutritionIrrigationData.data.find(
					(yObj) => String(yObj.year) === String(year),
				);
				if (!yearObj) {
					yearObj = { year, items: [] };
					this.stepData.nutritionIrrigationData.data.push(yearObj);
				}
				let monthObj = yearObj.items.find((mObj) => mObj.month === month);
				if (!monthObj) {
					monthObj = { month, dates: {} };
					yearObj.items.push(monthObj);
				}
				if (!monthObj.dates[formattedDate]) {
					monthObj.dates[formattedDate] = {
						irrigationTime: null,
						products: [],
					};
				}

				if (
					subCol &&
					subCol.dataField === 'irrigationTime' &&
					typeof updatedRow.irrigationTime !== 'undefined'
				) {
					monthObj.dates[formattedDate].irrigationTime =
						updatedRow.irrigationTime;
				}

				if (product && subCol && subCol.dataField !== 'irrigationTime') {
					let prodObj = monthObj.dates[formattedDate].products.find(
						(p) => p.prodId === product.id,
					);
					if (!prodObj) {
						prodObj = {
							prodId: product.id,
							name: product.name,
							dosis: null,
							totals: null,
							sectors: null,
						};
						monthObj.dates[formattedDate].products.push(prodObj);
					}

					if (subCol.dataField.endsWith('_dosis')) {
						prodObj.dosis = this.safeNumber(updatedRow[subCol.dataField]);
					}
					if (subCol.dataField.endsWith('_totales')) {
						prodObj.totals = this.safeNumber(updatedRow[subCol.dataField]);
					}
					if (subCol.dataField.endsWith('_sectores')) {
						prodObj.sectors = this.toArray(updatedRow[subCol.dataField]);
					}
				}
			},

			onRowUpdated(e) {
				const rowIndex = e.component.getRowIndexByKey(e.key);
				const prevRow = this.stepData.timeValues[rowIndex] || {};
				const updatedRow = { ...prevRow, ...e.data };

				if ('irrigationTime' in e.data) {
					updatedRow.irrigationTime = this.formatIrrigationTime(
						e.data.irrigationTime,
					);
				}
				this.$set(this.stepData.timeValues, rowIndex, updatedRow);

				if (!this.dataSourceDates || !this.dataSourceDates[rowIndex]) {
					console.warn(
						'dataSourceDates no está definido o el índice es incorrecto',
						rowIndex,
						this.dataSourceDates,
					);
					return;
				}
				const dateRow = this.dataSourceDates[rowIndex];
				if (!dateRow) return;

				const changedFields = Object.keys(e.data).filter(
					(field) => e.data[field] !== prevRow[field],
				);
				changedFields.forEach((field) => {
					// Busca el producto y subcolumna correspondiente SOLO para el campo modificado
					let found = false;
					if (field == 'irrigationTime') {
						// Actualiza la estructura interna para irrigationTime
						this.handleMassiveIrrigationSave(updatedRow.irrigationTime, [
							dateRow.key,
						]);
					} else {
						this.stepData.dosageProduct.forEach((product, prodIdx) => {
							if (found) return;
							const subCols = this.getAllSubColumns(product);
							const subCol = subCols.find((col) => col.dataField === field);
							if (subCol) {
								found = true;
								let dosis = null;
								let totales = null;
								let sectores = null;
								if (field.endsWith('_dosis')) {
									dosis = updatedRow[field];
									totales = this.calculateTotalsCell(dosis);
									sectores = updatedRow[`${product.code}_sectores`] ?? null;
								} else if (field.endsWith('_totales')) {
									dosis = updatedRow[`${product.code}_dosis`] ?? null;
									totales = updatedRow[field];
									sectores = updatedRow[`${product.code}_sectores`] ?? null;
								} else if (field.endsWith('_sectores')) {
									dosis = updatedRow[`${product.code}_dosis`] ?? null;
									totales = updatedRow[`${product.code}_totales`] ?? null;
									sectores = updatedRow[field];
								}
								const selectedDates = [dateRow.key];

								this.handleMassiveActionSave(
									{
										index: prodIdx,
										dosis,
										totales,
										sectores,
									},
									selectedDates,
								);
							}
						});
					}
				});
			},
			calculateTotalsCell(dosis) {
				let result = 0;
				if (this.selectedUnit === 1) {
					result = dosis * this.currentPlantation.area;
				} else if (this.selectedUnit === 2) {
					result = (dosis * this.actualPlantation.plants) / 1000;
				}
				return Math.round(result * 10) / 10;
			},

			onEditorPreparing(e) {
				switch (true) {
					case e.dataField === 'irrigationTime':
						this.checkingIrrigationTimeFormat(e);
						break;
					case e.dataField.endsWith('_dosis'):
						this.checkingDosisFormat(e);
						break;
					case e.dataField.endsWith('_totales'):
						this.checkingTotalesFormat(e);
						break;
					default:
						break;
				}
			},
			formatIrrigationTime(value) {
				let match = null;
				// Permite h, h:mm, hh:mm (sin ceros a la izquierda)
				match = String(value).match(/^(\d{1,2})(?::(\d{1,2}))?$/);
				if (match) {
					let hours = parseInt(match[1].replace(/^0+/, ''), 10) || 0;
					let minutes = match[2] ? parseInt(match[2], 10) : 0;
					if (hours > 23) {
						hours = 23;
						minutes = 59;
					}
					if (minutes > 59) minutes = 59;

					const formattedHours = hours;
					const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
					const minutesPart = formattedMinutes ? ':' + formattedMinutes : '';
					let newValue = '';
					if (!minutesPart || minutesPart === ':00') {
						newValue = formattedHours;
					} else {
						newValue = formattedHours + minutesPart;
					}
					return newValue;
				}
				return '';
			},
			/**
			 * Valida el formato de tiempo de riego (h:mm) en la celda editable.
			 * Permite solo números, dos puntos y controla el formato en tiempo real.
			 */
			checkingIrrigationTimeFormat(e) {
				e.editorOptions.onInput = (event) => {
					const input = event.event.target;
					let value = input.value;
					let match = null;
					match = value.match(/^(\d{0,2})(\:\d{0,2})?/);
					if (match) {
						const newValue = (match[1] || '') + (match[2] || '');
						if (value !== newValue) {
							input.value = newValue;
						}
					} else {
						input.value = '';
					}
				};
			},
			checkingDosisFormat(e) {
				e.editorOptions.onInput = (event) => {
					const input = event.event.target;
					let value = input.value;
					// Permite hasta 5 enteros y 1 decimal
					const match = value.match(/^(\d{0,5})(\.\d?)?/);
					if (match) {
						const newValue = (match[1] || '') + (match[2] || '');
						if (value !== newValue) {
							input.value = newValue;
							this.$notifyDX(
								{
									message:
										'El valor máximo permitido es 5 dígitos enteros y 1 decimal.',
									width: 550,
								},
								'warning',
								3000,
							);
						}
					}
				};
			},

			checkingTotalesFormat(e) {
				e.editorOptions.onInput = (event) => {
					const input = event.event.target;
					let value = input.value;
					// Permite hasta 7 enteros y 1 decimal
					const match = value.match(/^(\d{0,7})(\.\d?)?/);
					if (match) {
						const newValue = (match[1] || '') + (match[2] || '');
						if (value !== newValue) {
							input.value = newValue;
						}
					} else {
						input.value = '';
					}
				};
			},
			// Devuelve SIEMPRE las tres subcolumnas, controlando visibilidad con .visible
			getAllSubColumns(product) {
				let doseCaption = '';
				if (this.selectedUnit === 1) {
					doseCaption = product.presentation === 'LIQUIDO' ? 'L/ha' : 'Kg/ha';
				} else {
					doseCaption =
						product.presentation === 'LIQUIDO' ? 'cm3/pie' : 'g/pie';
				}

				let totalCaption = '';
				if (product.presentation === 'LIQUIDO') {
					totalCaption = 'Litros';
				} else if (product.presentation === 'SOLIDO') {
					totalCaption = 'Kg';
				}

				return [
					{
						caption: doseCaption,
						dataField: `${product.code}_dosis`,
						visible: true,
					},
					{
						caption: totalCaption,
						dataField: `${product.code}_totales`,
						visible:
							!this.showSectorDetails &&
							this.showTotals &&
							(product.presentation === 'LIQUIDO' ||
								product.presentation === 'SOLIDO'),
					},
					{
						caption: 'Sectores',
						dataField: `${product.code}_sectores`,
						visible: this.showSectorDetails && !this.showTotals,
					},
				];
			},
			fillTotalsFromDosis() {
				if (!Array.isArray(this.stepData.timeValues)) return;
				this.stepData.timeValues.forEach((row, rowIndex) => {
					this.stepData.dosageProduct.forEach((product) => {
						const doseField = `${product.code}_dosis`;
						const totalField = `${product.code}_totales`;
						const dosis = row[doseField];
						if (!this.isNullOrEmpty(dosis)) {
							row[totalField] = this.calculateTotalsCell(dosis);
							const dateRow = this.dataSourceDates[rowIndex];
							if (dateRow) {
								const dateStr = this.getDateStrFromRow(
									dateRow,
									this.stepData.temporalFrame.value,
								);
								const [year, monthNum, day] = dateRow.key.split('-');
								const month = moment(monthNum, 'MM')
									.locale('es')
									.format('MMMM');
								this.updateNutritionIrrigationData({
									year,
									month,
									dateStr,
									product,
									updatedRow: row,
									subCol: { dataField: totalField },
								});
							}
						}
					});
				});
				this.stepData.timeValues = [...this.stepData.timeValues];
			},
			onShowTotalsChanged(e) {
				if (e.value === true) {
					this.clearProductAttributeInNutritionIrrigationData('sectors');
					this.clearProductAttributeInTimeValues('sectores');
					this.fillTotalsFromDosis();
					this.stepData.nutritionIrrigationData.showSectorDetails = false;
				} else {
					this.clearProductAttributeInNutritionIrrigationData('totals');
					this.clearProductAttributeInTimeValues('totales');
				}
				this.stepData.nutritionIrrigationData.showTotals = e.value;
			},
			onShowSectorDetailsChanged(e) {
				if (
					e.value === true &&
					this.stepData.nutritionIrrigationData.showTotals === true
				) {
					this.clearProductAttributeInNutritionIrrigationData('totals');
					this.clearProductAttributeInTimeValues('totales');
					this.stepData.nutritionIrrigationData.showTotals = false;
				}
				if (!e.value) {
					this.clearProductAttributeInNutritionIrrigationData('sectors');
					this.clearProductAttributeInTimeValues('sectores');
				}
				this.stepData.nutritionIrrigationData.showSectorDetails = e.value;
			},
			clearProductAttributeInNutritionIrrigationData(attribute) {
				const data = this.stepData.nutritionIrrigationData.data;
				if (!Array.isArray(data)) return;
				data.forEach((yearObj) => {
					yearObj.items.forEach((monthObj) => {
						Object.values(monthObj.dates).forEach((dateObj) => {
							if (Array.isArray(dateObj.products)) {
								dateObj.products.forEach((product) => {
									product[attribute] = null;
								});
							}
						});
					});
				});
			},
			clearProductAttributeInTimeValues(attribute) {
				if (!Array.isArray(this.stepData.timeValues)) return;
				this.stepData.timeValues.forEach((row) => {
					Object.keys(row).forEach((key) => {
						if (key.endsWith(`_${attribute}`)) {
							row[key] = null;
						}
					});
				});
			},
			onEditorPreparingReadonlyCols(e) {
				if (['year', 'month', 'periodo'].includes(e.dataField)) {
					e.cancel = true;
				}
			},

			onContentReady(e) {
				e.component.columnOption('id', { visible: false });
			},
			selectProductItem(e) {
				if (!e.value) {
					this.productFertilizerSelected = '';
					return;
				}

				const product = this.productFertilizers.find(
					(item) => item.id === e.value,
				);

				if (product != null) {
					this.productFertilizerSelected = product;
					this.productFertilizerSelectedValue =
						this.productFertilizerSelected.name;
				}
			},
			getRowDataSource(titleColumn) {
				return {
					uf: titleColumn,
					n: 0,
					p: 0,
					k: 0,
					c: 0,
					m: 0,
					s: 0,
				};
			},
			toggleIrrigationTable() {
				this.buttonMessageIrrigation = this.showIrrigationTable
					? this.$t('dosageProduct.addIrrigationTable')
					: this.$t('dosageProduct.deleteIrrigationTable');
				this.showIrrigationTable = !this.showIrrigationTable;

				if (
					this.buttonMessageIrrigation ===
					this.$t('dosageProduct.deleteIrrigationTable')
				) {
					this.$notifyDX(
						{
							message: this.$t('dosageProduct.messageRecalculate'),
							width: 550,
						},
						'warning',
						6000,
					);
				}
			},
			async addProductFertilizer() {
				if (!this.productFertilizerSelected) {
					this.$notifyDX(
						{
							message: this.$t('requiredNutritionFertiliser'),
							width: 550,
						},
						'warning',
						3000,
					);
					return;
				}

				const { timeValues, timeValuesIrrigation } = getTimeValuesExtended(
					moment(this.stepData.initDate),
					moment(this.stepData.endDate),
					this.stepData.temporalFrame.id,
				);

				this.stepData.dosageProduct.push({ ...this.productFertilizerSelected });
				this.stepData.dosages.push({
					dosage: 0,
					presentation: this.productFertilizerSelected?.presentation,
					density: this.productFertilizerSelected?.density,
				});

				this.stepData.timeValues = this.stepData.timeValues.concat(timeValues);
				if (!this.isEditing) {
					this.stepData.timeValuesIrrigation =
						this.stepData.timeValuesIrrigation.concat(timeValuesIrrigation);
				}

				if (this.isEditing) {
					this.editingStepData.timeValues =
						this.editingStepData.timeValues.concat(timeValues);
				}

				if (this.isCopying) {
					this.copyingStepData.timeValues =
						this.copyingStepData.timeValues.concat(timeValues);
					this.copyingStepData.timeValuesIrrigation =
						this.copyingStepData.timeValuesIrrigation.concat(
							timeValuesIrrigation,
						);
				}

				await this.calculateReductionFertirrigation(
					this.stepData.dosageProduct.length - 1,
				);

				this.syncAvailableProductFertilizers();

				this.productFertilizerSelected = null;
				this.productFertilizerSelectedValue = null;

				this.$refs['product-fertilizer'].instance.reset();
				this.setIrrigationTableDataSource();
			},
			async calculateReductionFertirrigation(indexProduct) {
				const allReduction = this.stepData.dosageProduct.map(
					(i) => i?.reduction_percentage ?? 0,
				);
				const fertigationReduction = allReduction.length
					? Math.max(...allReduction)
					: 0;

				const actualProductReduction =
					this.productFertilizerSelected?.reduction_percentage ?? 0;

				this.reduceNutritionalNeeds(fertigationReduction);

				if (actualProductReduction === 0) {
					if (this.stepData.dosageProduct[indexProduct] != null) {
						await Api.getProductEfficiency({
							code: this.productFertilizerSelected.code,
							tipology: this.productFertilizerSelected.tipology,
							ph: this.stepData.ph,
						})
							.then((xhr) => {
								const data = JSON.parse(xhr.response);

								this.stepData.dosageProduct[indexProduct].eficiencies = {
									n: data.NT,
									p: data.P2015_Total,
									k: data.K2O,
									c: data.CaO,
									m: data.MgO,
									s: data.SO3,
								};
							})
							.catch((error) => {
								this.$notifyDX({ message: error, width: 550 }, 'error', 3000);
							});
					}
				} else {
					this.stepData.dosageProduct[indexProduct].eficiencies = {
						n: 100,
						p: 100,
						k: 100,
						c: 100,
						m: 100,
						s: 100,
					};
				}
			},
			reduceNutritionalNeeds(percentage) {
				const value = this.stepData.expectedProduction;

				this.calculateValue(
					this.stepData.nutritionalNeeds,
					'n',
					value,
					percentage,
				);
				this.calculateValue(
					this.stepData.nutritionalNeeds,
					'p',
					value,
					percentage,
				);
				this.calculateValue(
					this.stepData.nutritionalNeeds,
					'k',
					value,
					percentage,
				);
				this.calculateValue(
					this.stepData.nutritionalNeeds,
					'c',
					value,
					percentage,
				);
				this.calculateValue(
					this.stepData.nutritionalNeeds,
					'm',
					value,
					percentage,
				);
				this.calculateValue(
					this.stepData.nutritionalNeeds,
					's',
					value,
					percentage,
				);

				// Recalculamos datos como en el Paso 2
				this.stepData.nutritionalBalanceData[0] =
					this.stepData.nutritionalNeeds[1];
				this.stepData.nutritionalBalanceData[0].uf = this.$t(
					'nutritionalBalance.necNutritional',
				);

				this.calcTotalBalanceStep2(this.stepData.nutritionalBalanceData, 'n');
				this.calcTotalBalanceStep2(this.stepData.nutritionalBalanceData, 'p');
				this.calcTotalBalanceStep2(this.stepData.nutritionalBalanceData, 'k');
				this.calcTotalBalanceStep2(this.stepData.nutritionalBalanceData, 'c');
				this.calcTotalBalanceStep2(this.stepData.nutritionalBalanceData, 'm');
				this.calcTotalBalanceStep2(this.stepData.nutritionalBalanceData, 's');

				this.calcDosageProductBalanceStep2(
					this.stepData.nutritionalBalanceData,
				);

				this.dosageProductBalanceKey = `dosage-product-balance-key-${new Date().getTime()}`;
			},
			calcTotalBalanceStep2(array, param) {
				array[4][param] = this.roundValue(
					parseFloat(array[1][param]) +
						parseFloat(array[2][param]) +
						parseFloat(array[3][param]),
				);
				array[5][param] = this.roundValue(
					parseFloat(array[4][param]) - parseFloat(array[0][param]),
				);
			},
			calcDosageProductBalanceStep2(data) {
				const balance = data.find(
					(item) =>
						item?.uf === this.$t('nutritionalBalance.advanceFertilization'),
				);
				if (balance) {
					this.stepData.dosageProductBalance[0] = balance;
				}
			},
			calculateValue(array, param, value, reduccion = 0) {
				const percentage = 1 - reduccion / 100;

				array[1][param] = this.roundValue(array[0][param] * value * percentage);
			},
			roundValue(val) {
				return parseFloat(val.toFixed(1));
			},
			getCalculationByPresentation(data) {
				const { dosage, density, presentation } = data;
				const densityValue = density ?? 1;
				const cpPresentation = 'SOLIDO';
				if (presentation === cpPresentation) {
					return dosage;
				}
				return dosage * densityValue;
			},
			calculateUfEficency(array) {
				const ufContributed = {
					n: 0,
					p: 0,
					k: 0,
					c: 0,
					m: 0,
					s: 0,
				};

				const fixValue = (value) => {
					if (value == null) {
						return 0;
					}
					return parseFloat(value.toFixed(1));
				};

				this.stepData.dosageProduct.forEach((product, index) => {
					const dataCalculation = this.stepData.dosages[index];
					const calculation =
						this.getCalculationByPresentation(dataCalculation);
					if (product?.eficiencies != null) {
						ufContributed.n +=
							fixValue((calculation * product.n) / 100) *
							(product.eficiencies.n / 100);
						ufContributed.p +=
							fixValue((calculation * product.p) / 100) *
							(product.eficiencies.p / 100);
						ufContributed.k +=
							fixValue((calculation * product.k) / 100) *
							(product.eficiencies.k / 100);
						ufContributed.c +=
							fixValue((calculation * product.c) / 100) *
							(product.eficiencies.c / 100);
						ufContributed.m +=
							fixValue((calculation * product.m) / 100) *
							(product.eficiencies.m / 100);
						ufContributed.s +=
							fixValue((calculation * product.s) / 100) *
							(product.eficiencies.s / 100);
					} else {
						ufContributed.n +=
							fixValue((calculation * product.n) / 100) * (product.n / 100);
						ufContributed.p +=
							fixValue((calculation * product.p) / 100) * (product.p / 100);
						ufContributed.k +=
							fixValue((calculation * product.k) / 100) * (product.k / 100);
						ufContributed.c +=
							fixValue((calculation * product.c) / 100) * (product.c / 100);
						ufContributed.m +=
							fixValue((calculation * product.m) / 100) * (product.m / 100);
						ufContributed.s +=
							fixValue((calculation * product.s) / 100) * (product.s / 100);
					}
				});

				// UF eficientes aportadas redondeadas
				const ufContributedRounded = {
					n: fixValue(ufContributed.n),
					p: fixValue(ufContributed.p),
					k: fixValue(ufContributed.k),
					c: fixValue(ufContributed.c),
					m: fixValue(ufContributed.m),
					s: fixValue(ufContributed.s),
				};

				this.updateElementBalance(
					ufContributedRounded,
					this.stepData.dosageProductBalance[2],
				);

				// this.updateElementBalance(
				//   ufContributed,
				//   this.stepData.dosageProductBalance[3],
				// );

				this.differenceElementBalance('n');
				this.differenceElementBalance('p');
				this.differenceElementBalance('k');
				this.differenceElementBalance('c');
				this.differenceElementBalance('m');
				this.differenceElementBalance('s');
			},
			calcTotalBalance(array) {
				const ufContributed = {
					n: 0,
					p: 0,
					k: 0,
					c: 0,
					m: 0,
					s: 0,
				};

				this.stepData.dosageProduct.forEach((item, index) => {
					for (const prop in ufContributed) {
						ufContributed[prop] += this.calculateElementBalance(index, prop);
					}
				});

				this.updateElementBalance(
					ufContributed,
					this.stepData.dosageProductBalance[1],
				);

				this.updateElementBalance(
					ufContributed,
					this.stepData.dosageProductBalance[3],
				);

				this.differenceElementBalance('n');
				this.differenceElementBalance('p');
				this.differenceElementBalance('k');
				this.differenceElementBalance('c');
				this.differenceElementBalance('m');
				this.differenceElementBalance('s');
			},
			calculateElementBalance(index, prop) {
				const dataCalculation = this.stepData.dosages[index];
				const calculation = this.getCalculationByPresentation(dataCalculation);
				return Math.round(
					(this.stepData.dosageProduct[index][prop] / 100) * calculation,
				);
			},
			differenceElementBalance(prop) {
				// eslint-disable-next-line max-len
				// this.stepData.dosageProductBalance[3][prop] = Number(this.stepData.dosageProductBalance[0][prop])
				//   + Number(this.stepData.dosageProductBalance[1][prop])
				//   + Number(this.stepData.dosageProductBalance[2][prop]);
				// eslint-disable-next-line max-len
				this.stepData.dosageProductBalance[3][prop] =
					Number(this.stepData.dosageProductBalance[0][prop]) +
					Number(this.stepData.dosageProductBalance[2][prop]);

				this.stepData.dosageProductBalance[3][prop] = Number(
					this.stepData.dosageProductBalance[3][prop],
				).toFixed(1);
			},
			updateElementBalance(elementSource, elementTarget) {
				elementTarget.n = elementSource.n;
				elementTarget.p = elementSource.p;
				elementTarget.k = elementSource.k;
				elementTarget.c = elementSource.c;
				elementTarget.m = elementSource.m;
				elementTarget.s = elementSource.s;
			},
			deleteItem(item) {
				this.$f7.dialog.confirm(
					this.$t('dosageProduct.deleteDialogMessage', {
						product: this.stepData.dosageProduct[item.row.rowIndex].name,
					}),
					this.$t('dosageProduct.deleteDialogTitle'),
					() => {
						// Elimina las columnas del producto en cada fila de timeValues
						const product = this.stepData.dosageProduct[item.row.rowIndex];
						const code = product.code;
						const productId = product.id;

						this.stepData.timeValues.forEach((row) => {
							Object.keys(row).forEach((key) => {
								if (
									key === `${code}_dosis` ||
									key === `${code}_totales` ||
									key === `${code}_sectores`
								) {
									this.$delete(row, key);
								}
							});
						});

						// Elimina el producto de nutritionIrrigationData
						if (
							this.stepData.nutritionIrrigationData &&
							Array.isArray(this.stepData.nutritionIrrigationData.data)
						) {
							this.stepData.nutritionIrrigationData.data.forEach((yearObj) => {
								yearObj.items.forEach((monthObj) => {
									Object.values(monthObj.dates).forEach((dateObj) => {
										if (Array.isArray(dateObj.products)) {
											dateObj.products = dateObj.products.filter(
												(p) => p.prodId !== productId,
											);
										}
									});
								});
							});
						}

						// Elimina el producto y su resumen
						this.stepData.dosageProduct.splice(item.row.rowIndex, 1);
						this.stepData.dosages.splice(item.row.rowIndex, 1);
						this.stepData.productResume.splice(item.row.rowIndex, 1);

						this.syncAvailableProductFertilizers();

						// Ajusta las claves de irrigationTable
						let rowIndexToDelete = item.row.rowIndex;
						let suffixToDelete = `_${rowIndexToDelete}`;
						let keysToKeep = [];
						for (let key in this.stepData.irrigationTable) {
							if (key.endsWith(suffixToDelete)) {
								delete this.stepData.irrigationTable[key];
							} else {
								keysToKeep.push(key);
							}
						}
						keysToKeep.forEach((key) => {
							let adjustedKey = key.replace(/_\d+$/, (match) => {
								let index = parseInt(match.slice(1));
								if (index > rowIndexToDelete) {
									return `_${index - 1}`;
								}
								return match;
							});
							if (key !== adjustedKey) {
								this.stepData.irrigationTable[adjustedKey] =
									this.stepData.irrigationTable[key];
								delete this.stepData.irrigationTable[key];
							}
						});
						this.stepData.irrigationTable.forEach((obj) => {
							for (let key in obj) {
								if (
									key.startsWith('periods_product_irrigation_') ||
									key.startsWith('periods_dose_') ||
									key.startsWith('code_') ||
									key.startsWith('caption_')
								) {
									let index = parseInt(key.split('_').pop());
									if (index > rowIndexToDelete) {
										let newKey = key.replace(`_${index}`, `_${index - 1}`);
										obj[newKey] = obj[key];
										delete obj[key];
									}
								}
							}
						});

						if (this.stepData.dosageProduct.length === 0) {
							// borramos los datos de la tabla Riego de la store
							this.resetTimeValuesIrrigation();
							// logic to reset the balance
							this.$emit('resetBalance');
							// borramos los datos de la tabla Riego si no hay productos
							this.stepData.irrigationTable = [];
							// borramos el objeto de datos previos de la tabla Riego si no hay productos
							this.previousRowValues = {};
						}

						// Reconstruye la grid desde la estructura interna limpia
						this.mapNutritionIrrigationDataToGrid();
						this.calcTotalBalance(this.stepData.timeValues);
						this.calculateUfEficency(this.stepData.timeValues);
						this.calculateReductionFertirrigation();
					},
				);
			},
			openProductAnnotations(item) {
				const index = item.row.rowIndex;
				this.annotationProduct = {
					index,
					name: this.stepData.dosageProduct[index].name,
					observation: this.stepData.dosageProduct[index].observation ?? '',
				};
				this.showAnnotationProduct = true;
			},
			openMassiveAction(item, isIrrigationMasiveAction = false) {
				// Prepara los datos para el modal
				const index = item.row.rowIndex;
				this.isIrrigationMasiveAction = isIrrigationMasiveAction;
				this.massiveActionProduct = {
					index,
					dosis: null,
					totales: null,
					sectores: null,
					irrigationTime: null,
				};
				this.showMassiveAction = true;
			},
			handleMassiveIrrigationSave(irrigationTime, selectedDates) {
				const normalizedDates = this.normalizeDates(selectedDates);

				normalizedDates.forEach((selectedDate) => {
					const dateRow = this.dataSourceDates.find(
						(row) => row.key === selectedDate,
					);
					if (!dateRow) return;

					const dateStr = this.getDateStrFromRow(
						dateRow,
						this.stepData.temporalFrame.value,
					);

					let year = '',
						month = '',
						periodo = '';
					if (dateRow.key) {
						const [y, mm, d] = dateRow.key.split('-');
						year = y;
						month = moment(mm, 'MM').locale('es').format('MMMM');
						periodo = d;
					}

					// Actualiza SOLO la estructura interna
					this.updateNutritionIrrigationData({
						year,
						month,
						dateStr,
						product: null,
						updatedRow: { irrigationTime },
						subCol: { dataField: 'irrigationTime' },
					});
				});

				// Reconstruye la vista desde la estructura interna
				this.mapNutritionIrrigationDataToGrid();
				this.combineYearMonthCells(this.stepData.timeValues);
				this.calcTotalBalance(this.stepData.timeValues);
				this.calculateUfEficency(this.stepData.timeValues);
				this.keyGridDosages = uniqueId('key-grid-dosages-');
				this.showMassiveAction = false;
			},
			handleMassiveActionSave(data, selectedDates) {
				const { index, dosis, totales, sectores } = data;
				const product = this.stepData.dosageProduct[index];
				const subCols = this.getAllSubColumns(product);

				const normalizedDates = this.normalizeDates(selectedDates);

				normalizedDates.forEach((selectedDate) => {
					const dateRow = this.dataSourceDates.find(
						(row) => row.key === selectedDate,
					);
					if (!dateRow) return;

					const dateStr = this.getDateStrFromRow(
						dateRow,
						this.stepData.temporalFrame.value,
					);

					let year = '',
						month = '',
						periodo = '';
					if (dateRow.key) {
						const [y, mm, d] = dateRow.key.split('-');
						year = y;
						month = moment(mm, 'MM').locale('es').format('MMMM');
						periodo = d;
					}

					const dateIdx = this.dataSourceDates.findIndex(
						(row) => row.key === selectedDate,
					);
					if (dateIdx === -1) return;

					const row = this.stepData.timeValues[dateIdx] || {
						year,
						month,
						periodo,
						irrigationTime: null,
					};
					// Solo actualiza la columna correspondiente
					subCols.forEach((subCol) => {
						if (subCol.dataField.endsWith('_dosis')) {
							row[subCol.dataField] = this.safeNumber(dosis);
						}
						if (subCol.dataField.endsWith('_totales')) {
							if (totales) {
								row[subCol.dataField] = this.safeNumber(totales);
							} else if (dosis) {
								row[subCol.dataField] = this.calculateTotalsCell(dosis);
							} else {
								row[subCol.dataField] = null;
							}
						}
						if (subCol.dataField.endsWith('_sectores')) {
							row[subCol.dataField] = this.toArray(sectores);
						}
					});

					this.$set(this.stepData.timeValues, dateIdx, row);

					// Actualiza nutritionIrrigationData usando el método utilitario
					subCols.forEach((subCol) => {
						this.updateNutritionIrrigationData({
							year,
							month,
							dateStr,
							product,
							updatedRow: row,
							subCol,
						});
					});
				});

				if (normalizedDates.length > 0) {
					this.$set(
						this.stepData.dosageProduct[index],
						'selectedDates',
						normalizedDates,
					);
				}

				// Reiniciar dosages por producto
				this.stepData.dosages = this.calculateDosagesFromTimeValues();
				// Forzar que la tabla se renderice con los datos nuevos.
				this.stepData.dosages = [...this.stepData.dosages];

				this.mapNutritionIrrigationDataToGrid();
				this.combineYearMonthCells(this.stepData.timeValues);
				this.calcTotalBalance(this.stepData.timeValues);
				this.calculateUfEficency(this.stepData.timeValues);
				this.keyGridDosages = uniqueId('key-grid-dosages-');
				this.showMassiveAction = false;
			},
			calculateDosagesFromTimeValues() {
				return this.stepData.dosageProduct.map((product) => {
					const doseField = `${product.code}_dosis`;
					const totalField = `${product.code}_totales`;
					// Sumar todas las dosis de este producto en todas las filas
					const totalDosis = this.stepData.timeValues.reduce(
						(sum, row) => sum + (parseFloat(row[doseField]) || 0),
						0,
					);
					// Sumar todos los totales (columna "Totales", manuales o calculados
					// automáticamente a partir de la dosis) de este producto en todas las filas.
					// No se puede derivar de totalDosis: cuando el usuario solo rellena
					// "Totales" para un día, esa fila no tiene dosis y se perdería el dato.
					const totalAmount = this.stepData.timeValues.reduce(
						(sum, row) => sum + (parseFloat(row[totalField]) || 0),
						0,
					);
					return {
						code: product.code,
						dosage: Math.round(totalDosis * 10) / 10,
						totalAmount: Math.round(totalAmount * 10) / 10,
						presentation: product.presentation,
						density: product.density,
					};
				});
			},
			closeMassiveAction() {
				this.showMassiveAction = false;
			},
			save(e) {
				this.stepData.dosageProduct[e.index].observation = e.observation;
			},
			async viewProduct(item) {
				const { id } = this.stepData.dosageProduct.find(
					(product) => product.id === item.data.id,
				);

				this.$f7.preloader.show();
				try {
					await this.getNutritionalProductDetail(id);
				} catch (error) {
					const message = this.$helpers.getFilteredErrorMessage(error);
					if (message.includes('default_') && !message.includes('404')) {
						this.$notifyDX(
							{
								message: message.split('_').pop(),
								width: 550,
							},
							'error',
							3000,
						);
					} else if (!message.includes('404')) {
						this.$notifyDX(
							{
								message: this.$t(message),
								width: 550,
							},
							'error',
							3000,
						);
					}
				} finally {
					this.$f7.preloader.hide();
					this.showProductDetail = true;
				}
			},
			fixNumberTo(number, digits) {
				return parseFloat(parseFloat(number).toFixed(digits));
			},
			closeAnnotationProduct() {
				this.showAnnotationProduct = false;
			},
			getDosageKg(data) {
				const presentation = 'SOLIDO';
				const density = data.density ?? 1;

				if (data.presentation === presentation) {
					return this.fixNumberTo(data.dosage, 1);
				}

				return this.fixNumberTo(data.dosage * density, 1);
			},
			getDosageL(data) {
				const presentation = 'LIQUIDO';

				if (data.presentation === presentation) {
					return this.fixNumberTo(data.dosage, 1);
				}

				return '';
			},
			recalculateIrrigationTable() {
				this.stepData.timeValues.forEach((timeValue, indexTimeValue) => {
					Object.keys(timeValue).forEach((timeValueWeek) => {
						this.stepData.irrigationTable.forEach((irrigationItem) => {
							const weekValue = irrigationItem.week;

							if (weekValue === timeValueWeek) {
								const productKey = `periods_product_irrigation_${indexTimeValue}`;

								if (irrigationItem.hasOwnProperty(productKey)) {
									const periodsProductIrrigation = Math.floor(
										irrigationItem[productKey],
									);

									if (
										periodsProductIrrigation !== null &&
										periodsProductIrrigation !== 0
									) {
										const doseResult =
											timeValue[timeValueWeek] / periodsProductIrrigation;
										const doseKey = `periods_dose_${indexTimeValue}`;
										irrigationItem[doseKey] = this.fixNumberTo(doseResult, 1);
									} else {
										const doseKey = `periods_dose_${indexTimeValue}`;
										irrigationItem[doseKey] = 0;
									}
								}
							}
						});
					});
				});
			},
			handleCellValueChanging(e) {
				const { data } = e;
				let maxDose = 0;
				let dataIrrigationL = {};

				// Obtener los valores de timeValues
				const { timeValues } = this.stepData;

				// Nos aseguramos que la variable periods_irrigation_time tenga 2 decimales (Tiempo/Riego(horas))
				Object.keys(data).forEach((key) => {
					if (key === 'periods_irrigation_time') {
						data[key] = this.fixNumberTo(data[key], 2);
					}
				});

				// Nos aseguramos que la variable periods_irrigation no tenga decimales (NºTotal de Riegos))
				Object.keys(data).forEach((key) => {
					if (key === 'periods_irrigation') {
						data[key] = this.fixNumberTo(data[key], 0);
					}
				});

				if (
					data.periods_irrigation_time !==
						this.previousRowValues[data.week]?.periods_irrigation_time &&
					Object.keys(this.previousRowValues).length !== 0
				) {
					Object.keys(data).forEach((key) => {
						if (key.startsWith('periods_product_irrigation_')) {
							//Si el valor anterior de periods_product_irrigation_X es igual al del evento cambiado en ese momento que se actualice y se salga
							if (data[key] === this.previousRowValues[data.week]?.[key]) {
								const semanaEncontradaIndex =
									this.stepData.irrigationTable.findIndex(
										(item) => item.week === data.week,
									);
								this.stepData.irrigationTable[semanaEncontradaIndex] = data;
								return 0;
							}
						}
					});
				}

				timeValues.forEach((object, index) => {
					const weekValue = data.week;

					// Buscar la semana correspondiente en el objeto actual del timeValues
					if (object.hasOwnProperty(weekValue)) {
						const productKey = `periods_product_irrigation_${index}`;

						// Verificar si existe la clave correspondiente en el data(el evento)
						if (data.hasOwnProperty(productKey)) {
							const periodsProductIrrigation = Math.floor(data[productKey]);

							// Realizar la división si el valor no es null ni 0
							if (
								periodsProductIrrigation !== null &&
								periodsProductIrrigation !== 0
							) {
								const doseResult = object[weekValue] / periodsProductIrrigation;
								const doseKey = `periods_dose_${index}`;
								data[doseKey] = this.fixNumberTo(doseResult, 1); // Asignar el resultado de la división
							} else {
								const doseKey = `periods_dose_${index}`;
								data[doseKey] = 0; // Asignar 0 si periodsProductIrrigation es null
							}
						}
					}
				});

				// Nos aseguramos que la variable periods_product_irrigation_  sea un numero entero (NºRiegos)
				Object.keys(data).forEach((key) => {
					if (key.startsWith('periods_product_irrigation_')) {
						data[key] = this.fixNumberTo(data[key], 0);
					}
				});

				// Mostrar los resultados actualizados en data y actualizamos dataIrrigationL
				dataIrrigationL = data;

				// Calcular el valor máximo de 'periods_product_irrigation'
				for (let key in dataIrrigationL) {
					if (key.startsWith('periods_product_irrigation')) {
						maxDose = Math.max(
							Math.max(Math.floor(maxDose), data[key]),
							data['periods_irrigation'],
						);
					}
				}

				const semanaEncontradaIndex = this.stepData.irrigationTable.findIndex(
					(item) => item.week === data.week,
				);
				// Si se encuentra la semana se actualiza con todos los datos calculados de l/Riego
				this.stepData.irrigationTable[semanaEncontradaIndex] = dataIrrigationL;

				if (!this.previousRowValues[data.week]) {
					// Si no hay un registro anterior para esta semana, se agrega
					this.previousRowValues[data.week] = {
						...data,
						periods_irrigation: maxDose,
					};
					this.stepData.irrigationTable[
						semanaEncontradaIndex
					].periods_irrigation = maxDose;
				} else {
					// Se verifica si no hay cambios en 'periods_irrigation'
					if (
						data.periods_irrigation ===
						this.previousRowValues[data.week].periods_irrigation
					) {
						if (semanaEncontradaIndex !== -1) {
							// Si se encuentra la semana en el conjunto de datos, se actualiza 'periods_irrigation' con maxDose
							this.stepData.irrigationTable[
								semanaEncontradaIndex
							].periods_irrigation = maxDose;
						} else {
							// Si no se encuentra la semana, se agrega un nuevo objeto con los valores actualizados
							const nuevoObjeto = {
								...data,
								week: data.week,
								periods_irrigation: maxDose, // Asignar el valor de maxDose a 'periods_irrigation'
							};
							this.stepData.irrigationTable.push(nuevoObjeto);
						}
					}
					// Se actualiza el registro de valores anteriores con los nuevos valores
					this.previousRowValues[data.week] = { ...dataIrrigationL };
				}
			},
			setIrrigationTableDataSource() {
				// Si estamos en el modo edición
				if (this.isEditing) {
					// Hacemos el calculo para poner el nombre de la dosis L o KG segun si es Liquido o Solido
					const dosageProduct = (this.stepData.dosageProduct =
						this.stepData.dosageProduct.map((product) => ({
							...product,
							caption:
								product.presentation === 'LIQUIDO' ? 'l/Riego' : 'kg/Riego',
						})));

					const lastIndex = dosageProduct.length - 1;
					const lastProduct = dosageProduct[lastIndex];

					const newTimeValuesIrrigation = {
						[`code_${lastIndex}`]: lastProduct.code,
						[`periods_dose_${lastIndex}`]: 0,
						[`periods_product_irrigation_${lastIndex}`]: 0,
						[`caption_${lastIndex}`]: lastProduct.caption,
					};
					// Agregar los nuevos valores del último producto a cada objeto del array this.stepdata.irrigationTable
					this.stepData.irrigationTable.forEach((obj) => {
						Object.keys(newTimeValuesIrrigation).forEach((key) => {
							// Usamos set para que al añadir los atributos nuevos mantenga la reactividad
							this.$set(obj, key, newTimeValuesIrrigation[key]);
						});
					});
				} else {
					const timeValuesIrrigation = this.stepData.timeValuesIrrigation;

					// Hacemos el calculo para poner el nombre de la dosis L o KG segun si es Liquido o Solido
					const dosageProduct = (this.stepData.dosageProduct =
						this.stepData.dosageProduct.map((product) => {
							return {
								...product,
								caption:
									product.presentation === 'LIQUIDO' ? 'l/Riego' : 'kg/Riego',
							};
						}));

					// Limpiar los datos de la Tabla de riego stepData.irrigationTable
					this.stepData.irrigationTable = [];
					// Datos anteriores lo limpiamos
					this.previousRowValues = {};

					for (const week in timeValuesIrrigation[0]) {
						if (Object.hasOwnProperty.call(timeValuesIrrigation[0], week)) {
							const newTimeValuesIrrigation = {};
							newTimeValuesIrrigation.week = week;

							dosageProduct.forEach((product, indexProduct) => {
								const code = product.code;
								const timeValuesIrrigationProduct =
									timeValuesIrrigation[indexProduct];
								const { periods_dose, periods_product_irrigation } =
									timeValuesIrrigationProduct[week];
								newTimeValuesIrrigation[`code_${indexProduct}`] = code;
								newTimeValuesIrrigation[`periods_dose_${indexProduct}`] =
									periods_dose;
								newTimeValuesIrrigation[
									`periods_product_irrigation_${indexProduct}`
								] = periods_product_irrigation;
								newTimeValuesIrrigation[`caption_${indexProduct}`] =
									product.caption;
							});
							newTimeValuesIrrigation.periods_irrigation = 0;
							newTimeValuesIrrigation.periods_irrigation_time = 0;

							this.stepData.irrigationTable.push(newTimeValuesIrrigation);
						}
					}
				}
			},
			onSectorCellClick(e) {
				if (!e.row || !e.row.data) return;
				if (
					e.row.data.year === 'Totales' ||
					e.row.data.year === 'Total líquidos g-Kg'
				)
					return;
				if (
					e.column &&
					typeof e.column.dataField === 'string' &&
					e.column.dataField.endsWith('_sectores')
				) {
					let productCode = null;
					const productIndex = this.stepData.dosageProduct.findIndex(
						(product) => {
							productCode = product.code;
							return e.column.dataField.startsWith(productCode);
						},
					);
					this.selectedSectorCell = {
						productIndex: productIndex,
						productCode: productCode,
						rowData: e.row.data,
						rowIndex: e.rowIndex,
						value: e.key[e.column.dataField] || [],
						key: e.key.key,
					};
					this.showSectorModal = true;
				}
			},
			handleSectorSave(updatedCell) {
				this.handleMassiveActionSave(
					{
						index: updatedCell.productIndex,
						dosis: updatedCell.rowData[`${updatedCell.productCode}_dosis`],
						totales: null,
						sectores: updatedCell.value,
					},
					[updatedCell.key],
				);
				this.showSectorModal = false;
			},
			viewNutritionProduct(product) {
				this.showNutritionProductDetail = true;
				this.nutritionProduct = this.stepData.dosageProduct.find(
					(p) => p.id === product.data.id,
				);
			},
			formatSectorCell(data) {
				const columnName = data.column.dataField;
				data.value = data.key[columnName];
				if (Array.isArray(data.value)) {
					return data.value.join(', ');
				} else {
					return data.value;
				}
			},
		},
	};
</script>
<style src="./dosageProduct.scss" scoped lang="scss"></style>
